import React from 'react';
import FilePreviewPlugin from '../MessagePreview/Plugins/FilePreviewPlugin';


/**
 * Native uploaded file attachment (message.file) — distinct from
 * ReadOnlyUrlMetaPreview's media fields, which cover video/audio attached to
 * a *linked page* (urlMeta.media_url). This is for a file the user actually
 * uploaded to Luckynote. Previously all three read-only components showed
 * every file type as a plain filename row (matching FileSection.js's
 * type?.includes('video') detection, but without the inline <video>/<audio>
 * player FileSection actually renders) — video and audio attachments had no
 * playback at all, just a name.
 */
const ReadOnlyFilePreview = ({ file, onOpenWorkspace }) => {
    if (!file?.name) return null;
    return <FilePreviewPlugin readOnly hideAddButton message={{ file }} onOpenVideoWorkspace={onOpenWorkspace ? (_, source) => onOpenWorkspace(source) : undefined} />;
};

export default ReadOnlyFilePreview;
